import type { FC, SVGProps } from 'react'
import BiTwitterX from '~icons/bi/twitter-x'
import IcBaselineDiscord from '~icons/ic/baseline-discord'
import IconParkSolidGift from '~icons/icon-park-solid/gift'
import IconParkSolidYoutube from '~icons/icon-park-solid/youtube'
import MdiInstagram from '~icons/mdi/instagram'
import MdiYoutube from '~icons/mdi/youtube'
import RiTiktokFill from '~icons/ri/tiktok-fill'
import RiTwitterXLine from '~icons/ri/twitter-x-line'

type IconComponent = FC<SVGProps<SVGSVGElement>>

/**
 * Registry mapping backend icon identifiers to unplugin-icons components.
 *
 * Format: "collection:icon-name" → component
 *
 * To add a new icon, import it from `~icons/` and add an entry here.
 */
const questIconRegistry: Record<string, IconComponent> = {
  'icon-park-solid:gift': IconParkSolidGift,
  'icon-park-solid:youtube': IconParkSolidYoutube,
  'bi:twitter-x': BiTwitterX,
  'ri:twitter-x-line': RiTwitterXLine,
  'ic:baseline-discord': IcBaselineDiscord,
  'mdi:instagram': MdiInstagram,
  'mdi:youtube': MdiYoutube,
  'ri:tiktok-fill': RiTiktokFill,
}

export function resolveQuestIcon(key: string | null): IconComponent | null {
  if (!key) return null
  return questIconRegistry[key] ?? null
}
